// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import _ from 'lodash';
import OlProj from 'ol/proj';
import OlLayerVector from 'ol/layer/vector';
import OlSourceVector from 'ol/source/vector';
import OlGeomPoint from 'ol/geom/point';
import OlFeature from 'ol/feature';
import OlStyleStyle from 'ol/style/style';
import OlStyleIcon from 'ol/style/icon';
import { getSelectInteractionManager } from '../../../../utilities/selectInteractionManager';
import { selectPhoto } from '../../../../actions/photos';
import PhotoSymbol from '../../../../icons/Photo_symbol.svg';
import PhotoDirectionSymbol from '../../../../icons/Photo_direction_symbol.svg';
import PhotoSymbolSelected from '../../../../icons/Photo_symbol_selected.svg';
import PhotoDirectionSymbolSelected from '../../../../icons/Photo_direction_symbol_selected.svg';

const PHOTOS_LAYER_NAME = 'Photos';
// a javascript object literal can be used to cache
// previously created styles. Its very important for
// performance to cache styles. Maximum styles count 360.
const styleCache = {};
const styleSelectedCache = {};
const defaultStyle = new OlStyleStyle({
    image: new OlStyleIcon({
        src: PhotoSymbol,
        scale: 0.5
    })
});
const defaultStyleSelected = new OlStyleStyle({
    image: new OlStyleIcon({
        src: PhotoSymbolSelected,
        scale: 0.5
    })
});

export class PhotoLayer extends React.Component {
    photosSource = null;
    displayedFeatures = [];

    constructor(props) {
        super(props);
        const { olMap } = props;

        this.photosSource = new OlSourceVector();
        const photosLayer = new OlLayerVector({
            source: this.photosSource,
            showInLegend: true,
            visible: true,
            zIndex: 1000002,
            name: PHOTOS_LAYER_NAME,
            style: this.getStyle
        });

        olMap.addLayer(photosLayer);
        this.addPhotoSelectInteraction();
    }

    //source http://openlayersbook.github.io/ch06-styling-vector-layers/example-07.html
    getStyle(feature, resolution) {
        let rotation = feature.get('yaw');
        if (rotation === null) {
            return [defaultStyle];
        }

        rotation = Math.round(rotation);
        if (!styleCache[rotation]) {
            styleCache[rotation] = new OlStyleStyle({
                image: new OlStyleIcon({
                    src: PhotoDirectionSymbol,
                    scale: 0.5,
                    rotation: rotation / 180 * Math.PI,
                    rotateWithView: true,
                })
            });
        }
        return [styleCache[rotation]];
    }

    getStyleSelected(feature, resolution) {
        let rotation = feature.get('yaw');
        if (rotation === null) {
            return [defaultStyleSelected];
        }

        rotation = Math.round(rotation);
        if (!styleSelectedCache[rotation]) {
            styleSelectedCache[rotation] = new OlStyleStyle({
                image: new OlStyleIcon({
                    src: PhotoDirectionSymbolSelected,
                    scale: 0.5,
                    rotation: rotation / 180 * Math.PI,
                    rotateWithView: true,
                })
            });
        }
        return [styleSelectedCache[rotation]];
    }

    addPhotoSelectInteraction() {
        const selectConfig = {
            style: this.getStyleSelected,
            idColumnName: 'id',
            layerName: PHOTOS_LAYER_NAME,
            onFeatureSelect: this.onSelectPhotoFeature.bind(this),
        }
        getSelectInteractionManager('map').addSelectConfig(selectConfig);
    }

    onSelectPhotoFeature(id) {
        this.props.selectPhoto(id);
    }

    selectPhotoFeature() {
        const { selectedPhotoId } = this.props;
        if (selectedPhotoId) {
            const selectedFeature = this.displayedFeatures.find(feature => {
                return feature.get('id') === selectedPhotoId;
            });
            getSelectInteractionManager('map').selectFeature(PHOTOS_LAYER_NAME, selectedFeature);
        } else {
            getSelectInteractionManager('map').selectFeature(PHOTOS_LAYER_NAME, null);
        }
    }

    updatePhotoFeatures() {
        const { photos } = this.props;
        this.displayedFeatures = [];
        this.photosSource.clear();
        if (!photos) return;

        this.displayedFeatures = photos
            .filter(photo => photo.longitude && photo.latitude)
            .map(photo => {
                const transformedCoords = OlProj.transform([photo.longitude, photo.latitude], "EPSG:4326", "EPSG:3857");
                const point = new OlGeomPoint(transformedCoords, 'XY');
                const feature = new OlFeature({
                    geometry: point,
                    id: photo.id,
                    layerName: PHOTOS_LAYER_NAME,
                    yaw: photo.yaw
                });
                this.photosSource.addFeature(feature);
                return feature;
            });
    }

    componentDidUpdate(prevProps) {
        const {
            photos,
            selectedPhotoId
        } = this.props;

        if (!_.isEqual(prevProps.photos, photos)) {
            this.updatePhotoFeatures();
        }
        if (!_.isEqual(prevProps.photos, photos) || prevProps.selectedPhotoId !== selectedPhotoId) {
            this.selectPhotoFeature();
        }
    }

    render() {
        return null;
    }
};

const mapStateToProps = state => ({
    photos: state.photos.get('photos'),
    selectedPhotoId: state.photos.get('selectedPhotoId'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    selectPhoto
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PhotoLayer);


// WEBPACK FOOTER //
// ./src/containers/content/map/photos/PhotoLayer.jsx